export const paramIdFromHash = (hash) => {
  if (hash.includes('#/')) {
    return hash.replace('#/', '')
  }
  return null
}
